import * as React from "react"
import { TestState } from "../utils/common"
import "./detailstyles.css"
import { ConnectionTest, ConnectionTestGroup, eltbit, groupStatus } from "./domutils"
import Spinner from "./progress.gif"
import ThumbsDown from "./ThumbsDown.svg"
import ThumbsUp from "./ThumbsUp.svg"

function renderBits(bits: Array<eltbit>): Array<string | React.ReactElement> {
    let parts: Array<string | React.ReactElement> = []
    bits.forEach((it) => { appendBit(parts, it) });
    return parts
}

function appendBit(onto: Array<string | React.ReactElement>, it: eltbit) {
    if (typeof(it) === 'string') {
        onto.push(it)
    } else {
        let childTag: string = ( it.elt || 'span' )
        var childProps
        if (it.cls !== undefined) {
            childProps = { className: it.cls }
        } else {
            childProps = { }
        }
        let content = it.value;
        if (typeof(content) === 'string') {
            onto.push(React.createElement(childTag, childProps, content))
        } else {
            onto.push(React.createElement(childTag, childProps, ...renderBits(content)))
        }
    }
}

function Banner(props: { status: TestState, summary: eltbit[] }): React.ReactElement {
    return React.createElement(React.Fragment, null,
                               "\u{00A0}", ...renderBits(props.summary))
}

function TestDetail(props: { summary: eltbit[] }): React.ReactElement {
    return React.createElement('div', { className: "testdetail" }, ...renderBits(props.summary))
}

class TestInformation extends React.Component<ConnectionTest> {
    render() {
        let deets = this.props.details

        if (deets === undefined) {
            return Banner(this.props)
        }

        let parts = [ <p>{Banner(this.props)}</p> ]

        if (deets !== undefined) {
            deets.forEach( (deet) => parts.push(<TestDetail summary={deet} />) )
        }

        return React.createElement(React.Fragment, null, ...parts)
    }
}

function statusToCSS(stat: TestState): React.CSSProperties {
	let imgName = (stat === TestState.InProgress) ? Spinner : ((stat === TestState.Ok) ? ThumbsUp : ThumbsDown)
    let props: React.CSSProperties = {listStyleImage:  "url('" + imgName + "')"}
    return props
}

function subtestListItem(subtest: ConnectionTest | ConnectionTestGroup): React.ReactElement {
    if (subtest.hasOwnProperty('subtests')) {
        let st = subtest as ConnectionTestGroup
        let groupstat = groupStatus(st)
        let props = statusToCSS(groupstat)
        return <li key={subtest.identifier} className={groupstat} style={props}><TestInformationGroup groupStatus={groupstat} {...st} /></li>
    } else {
        let st = subtest as ConnectionTest
        let props = statusToCSS(st.status)
        return <li key={subtest.identifier} className={st.status} style={props}><TestInformation {...st} /></li>
    }
}

class TestInformationGroup extends React.Component<ConnectionTestGroup & { groupStatus: TestState }> {
    render() {
        return <><p><Banner status={this.props.groupStatus} summary={this.props.summary} /></p><ul>{ this.props.subtests.map((i) => subtestListItem(i)) }</ul></>;
    }
}

type DetailedTestGroupProps = { tests: Array<ConnectionTest | ConnectionTestGroup> }
class DetailedTestGroup extends React.Component<DetailedTestGroupProps> {
    render() {
        let items = this.props.tests.map((i) => subtestListItem(i))
        return <><div role="complementary" id="detailbox"><ul id="checklist">{items}</ul></div></>
    }
}

export { subtestListItem, DetailedTestGroup }
